import { FONT_FAMILIES } from 'ia-react-core';
import styled from 'styled-components';

const Custom = {
  HEIGHT: '60px',
};

export const StyledContentDiv = styled.div`

  display: none;
  position: sticky;
  top: 0;
  z-index: 100;

  .smartbanner-show & {
    display: block;
  }

  .smartbanner {
    &.smartbanner-top {
      height: ${Custom.HEIGHT};
      line-height: ${Custom.HEIGHT};
      background-color: #F0F0EF;
      font-family: ${FONT_FAMILIES.OPEN_SANS};
      box-shadow: none;
      position: static;
    }

    .smartbanner-container {
      display: flex;
      margin: 10px 16px;
      padding: 0px;
      justify-content: space-between;
      -webkit-box-align: center;
      align-items: center;
      -webkit-box-pack: justify;

      .smartbanner-close {
        max-width: 13px;
        width: 100%;
        height: 13px;
        margin: 0;

        font-size: 13px;
        line-height: 12px;
        font-family: 'Times New Roman', Times, serif;

        color: rgb(32, 98, 212);
        background: transparent;
        text-shadow: none;
        box-shadow: none;
        border: 1px solid rgb(32, 98, 212);
      }
    }

    .smartbanner-icon {
      margin: 0;
      width: 40px;
      height: 40px;
      border-radius: 0;
      box-shadow: rgba(0, 0, 0, 0.15) 0px 1px 0px 0px;
    }

    .smartbanner-info {
      margin: auto 0;
      font-size: 14px;
      line-height: 1.3em;
      text-shadow: none;
    }

    .smartbanner-title {
      margin: 0px;
      font-size: inherit;
      line-height: inherit;
      font-weight: 500;
      color: rgb(27, 27, 27);
    }

    .smartbanner-author {
      color: rgb(27, 27, 27);
      font-size: inherit;
      line-height: inherit;
      font-weight: bold;
    }

    .smartbanner-description {
      display: none;
    }

    .smartbanner-wrapper {
      height: 40px;
      line-height: 40px;
    }

    .smartbanner-button {
      color: white;
      height: inherit;
      padding: 0 12px;
      line-height: inherit;
      font-weight: 600;
      background: rgb(0, 61, 165);
      border-color: rgb(255, 255, 255);
      border-radius: 4px;
      box-shadow: none;
    }

    .smartbanner-button-text {
      display: inline-block;
      padding: 0;
      background: transparent;
      height: inherit;
      line-height: inherit;
      text-transform: none;
    }
  }
`;
